import React from 'react'

import '../styles/stories.css'
import { FaStar, FaRegStar } from "react-icons/fa";
import images from '../assets/testimoney'

const Stories = () => {
  return (
    <>
      <div className="stories">
        <div className="hdr">
          <h3>Success <span>Stories</span></h3>
          <p>Real results from real community members</p>
          <div className="ratn">
            <div className="strs">
              <FaStar />
              <FaStar />
              <FaStar />
              <FaStar />
              <FaStar />
            </div>
            <p>5.0 on Whop</p>
          </div>
        </div>
        <div className="carousel sel">
          <ul>
            <li>
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>
              <div className="comment">
                <p>best investment ive made tbh. ROI is insane the automated signals are just unmatched</p>
              </div>
              <div className="prof">
                <div className="pfp">EL</div>
                <div className="names">
                  <h4>@elickz</h4>
                  <p>$156,000 in 6 month</p>
                </div>
              </div>
              <div className="imgs">
                <div className="img" style={{ backgroundImage: `url(${images.cashm})` }}></div>
              </div>
            </li>
            <li>
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaRegStar />
              </div>
              <div className="comment">
                <p>Thanks to the trading signals I bought my first car at 22!! From zero experience to my dream Mercedes in 4 months 💎</p>
              </div>
              <div className="prof">
                <div className="pfp">SR</div>
                <div className="names">
                  <h4>@sarah.rdgrz</h4>
                  <p>$92,500 in first quater</p>
                </div>
              </div>
              <div className="imgs">
                <div className="img" style={{ backgroundImage: `url(${images.testimonie1})` }}></div>
              </div>
            </li>
            <li>
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>
              <div className="comment">
                <p>small payout but it proved the process works. caught the signal, managed risk, and got paid out without overthinking it</p>
              </div>
              <div className="prof">
                <div className="pfp">E</div>
                <div className="names">
                  <h4>@vivianafx</h4>
                  <p>$250 payout request</p>
                </div>
              </div>
              <div className="imgs">
                <div className="img" style={{ backgroundImage: `url(${images.vvian})` }}></div>
              </div>
            </li>
          </ul>
          <ul aria-hidden>
            <li>
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaRegStar />
              </div>
              <div className="comment">
                <p>biggest certificate i've ever received. used the signals as confirmation and scaled only when the setup was there</p>
              </div>
              <div className="prof">
                <div className="pfp">E</div>
                <div className="names">
                  <h4>@matthew.l</h4>
                  <p>$80,344.04 payout</p>
                </div>
              </div>
              <div className="imgs">
                <div className="img" ></div>
              </div>
            </li>
            <li>
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>
              <div className="comment">
                <p>ETH long signal was insane. waited for confirmation, entered clean, and rode the move without getting shaken out</p>
              </div>
              <div className="prof">
                <div className="pfp">DB</div>
                <div className="names">
                  <h4>@dboetrader</h4>
                  <p>+465.45% ETH/USDT</p>
                </div>
              </div>
              <div className="imgs">
                <div className="img" style={{ backgroundImage: `url(${images.dboe})` }}></div>
              </div>
            </li>
            <li>
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>
              <div className="comment">
                <p>built my SOL stack and the account finally crossed 154k. signals plus discipline changed everything for me</p>
              </div>
              <div className="prof">
                <div className="pfp">jS</div>
                <div className="names">
                  <h4>@moneymakah</h4>
                  <p>$156,176.84 wallet</p>
                </div>
              </div>
              <div className="imgs">
                <div className="img" style={{ backgroundImage: `url(${images.solan})` }}></div>
              </div>
            </li>
          </ul>
        </div>
        <div className="carousel">
          <ul>
            <li>
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaRegStar />
              </div>
              <div className="comment">
                <p>started nervous with only 500.. their MSFT signal helped me make 275 profit building confidence one trade at a time</p>
              </div>
              <div className="prof">
                <div className="pfp">CB</div>
                <div className="names">
                  <h4>@crisbaker</h4>
                  <p>$245 MSFT trade</p>
                </div>
              </div>
              <div className="imgs">
                <div className="img" ></div>
              </div>
            </li>
            <li>
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>
              <div className="comment">
                <p>work full time but follow their after hours signals.. made 890 on GOOGL earnings play from my phone during lunch break</p>
              </div>
              <div className="prof">
                <div className="pfp">WT</div>
                <div className="names">
                  <h4>@workingtrader</h4>
                  <p>$890 GOOGL trade</p>
                </div>
              </div>
              <div className="imgs">
                <div className="img" ></div>
              </div>
            </li>
          </ul>
          <ul aria-hidden>
            <li>
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>
              <div className="comment">
                <p>first funded reward hit and it felt unreal. the alerts helped me stop guessing and start waiting for clean setups</p>
              </div>
              <div className="prof">
                <div className="pfp">E</div>
                <div className="names">
                  <h4>@saketG</h4>
                  <p>$503.20 reward</p>
                </div>
              </div>
              <div className="imgs">
                <div className="img" style={{ backgroundImage: `url(${images.saket})` }}></div>
              </div>
            </li>
            <li>
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaRegStar />
              </div>
              <div className="comment">
                <p>FTMO payout came through after weeks of sticking to the plan. Tradevisor kept me from forcing bad trades</p>
              </div>
              <div className="prof">
                <div className="pfp">E</div>
                <div className="names">
                  <h4>@ibnouTall</h4>
                  <p>$13,652.31 profit split</p>
                </div>
              </div>
              <div className="imgs">
                <div className="img" style={{ backgroundImage: `url(${images.ibnou})` }}></div>
              </div>
            </li>
            <li>
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>
              <div className="comment">
                <p>passed the combine and finally got certified funded. the biggest change was patience — I only took the high quality alerts</p>
              </div>
              <div className="prof">
                <div className="pfp">E</div>
                <div className="names">
                  <h4>@amineB</h4>
                  <p>certified funded trader</p>
                </div>
              </div>
              <div className="imgs">
                <div className="img" style={{ backgroundImage: `url(${images.amine})` }}></div>
              </div>
            </li>
            <li>
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaRegStar />
              </div>
              <div className="comment">
                <p>QQQ puts signal before tech selloff was AMAZING made 1520 when market dropped 3% that day</p>
              </div>
              <div className="prof">
                <div className="pfp">PT</div>
                <div className="names">
                  <h4>@putking_</h4>
                  <p>$1,520 QQQ points</p>
                </div>
              </div>
              <div className="imgs">
                <div className="img" ></div>
              </div>
            </li>
            <li>
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>
              <div className="comment">
                <p>From $3,000 to $256,880 in my checking account in just 8 months! The trading algorithms and smart insights completely transformed my financial life.</p>
              </div>
              <div className="prof">
                <div className="pfp">RC</div>
                <div className="names">
                  <h4>@robertchang98</h4>
                  <p>$256,880 account balance</p>
                </div>
              </div>
              <div className="imgs">
                <div className="img" style={{ backgroundImage: `url(${images.testimonie})` }}></div>
              </div>
            </li>
            <li>
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>
              <div className="comment">
                <p>dropped out after making 225k trading... best decision ever why study when u can earn this much lol</p>
              </div>
              <div className="prof">
                <div className="pfp">E</div>
                <div className="names">
                  <h4>@genji7</h4>
                  <p>$225,000 in 8 months</p>
                </div>
              </div>
              <div className="imgs">
                <div className="img" style={{ backgroundImage: `url(${images.cashmail})` }}></div>
              </div>
            </li>
            <li>
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaRegStar />
              </div>
              <div className="comment">
                <p>locked in a 32k profit split after following the entries and risk rules. Tradevisor gave me the confidence to hold the setup properly</p>
              </div>
              <div className="prof">
                <div className="pfp">NT</div>
                <div className="names">
                  <h4>@nikolasTrade</h4>
                  <p>$32,000 profit split</p>
                </div>
              </div>
              <div className="imgs">
                <div className="img" style={{ backgroundImage: `url(${images.niclas})` }}></div>
              </div>
            </li>
            <li>
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaRegStar />
              </div>
              <div className="comment">
                <p>ngl this platform literally changed my life!! went from broke to 13k in like 3 months just following the signals 🚀</p>
              </div>
              <div className="prof">
                <div className="pfp">DV</div>
                <div className="names">
                  <h4>@dvrt</h4>
                  <p>$13,000 first 90 days</p>
                </div>
              </div>
              <div className="imgs">
                <div className="img" style={{ backgroundImage: `url(${images.niclas})` }}></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}

export default Stories